import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-alt-circle-right': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5v70.9h-116c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z'
      }
    ]
  }
})
